import {ArticleDetailDto, IArticlesWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, Router} from "@angular/router";

@Injectable()
export class ArticleDetailResolver implements Resolve<ArticleDetailDto> {

  constructor(private articleWebService: IArticlesWebServiceClient, private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    let articleId: number = Number(route.paramMap.get('id'));
    let article = this.articleWebService.recupererArticle(articleId);
    article.subscribe(allowed => {

    }, (error) => {
      this.router.navigate(['cerba/categories/liste']);
    })
    return article;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/article-detail/article.detail.resolver.ts